<template>
  <div class="page-container product-editor">
    <div class="page-title-container">
      <h1 class="page-title">
        {{ editing ? "Editar supervisor" : "Nuevo supervisor" }}
      </h1>
    </div>
    <div class="container px-0">
      <div class="row justify-content-center">
        <div class="col-12">
          <b-card
            tag="article"
            no-body
            style="max-width: 760px"
            class="custom-card"
          >
            <b-card-header
              header-tag="section"
              class="custom-card-header d-flex align-items-center"
            >
              <h3>
                {{
                  editing
                    ? "Datos del supervisor"
                    : "Datos del nuevo supervisor"
                }}
              </h3>
            </b-card-header>
            <b-card-body class="custom-card-body px-0 pb-0">
              <form class="custom-form" @submit.prevent="save" novalidate>
                <div class="form-section pt-0">
                  <h2 class="custom-card-subtitle mb-4">
                    Información personal
                  </h2>
                  <div class="row">
                    <div class="col-12">
                      <div class="form-group mb-0">
                        <label for="name"
                          >Nombre del colaborador *</label
                        >

                        <FormInput
                          id="name"
                          type="text"
                          placeholder="Ingresar nombre del colaborador"
                          :show-error="
                            $v.form.name.$error && !$v.form.name.required
                          "
                          v-model="form.name"
                        />

                        <form-error
                          message="Nombre del colaborador es requerido"
                          v-if="$v.form.name.$error && !$v.form.name.required"
                        ></form-error>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="form-section pb-0 border-0">
                  <h2 class="custom-card-subtitle mb-4">Información Laboral</h2>

                  <div class="row">
                    <div class="col-md-6">
                      <div class="form-group">
                        <label for="supervisorType">Tipo de supervisor</label>

                        <FormSelect
                          id="supervisorType"
                          :show-error="
                            $v.form.supervisorType.$error && !$v.form.supervisorType.required
                          "
                          v-model="form.supervisorType"
                          :items="supervisorTypes"
                          defaultOption="Elegir tipo de supervisor"
                        />
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-12">
                      <div class="form-group">
                        <label for="zonales">Zonales</label>

                        <b-form-group>
                          <b-form-checkbox-group
                            id="seller-zonal-checkbox-list"
                            v-model="form.zonal"
                            :options="zonalList"
                            name="zonales"
                          ></b-form-checkbox-group>
                        </b-form-group>

                        <form-error
                          message="Zonal es requerido"
                          v-if="$v.form.zonal.$error && !$v.form.zonal.required"
                        ></form-error>
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-12">
                      <div class="form-group mb-0">
                        <label for="supervisors">Supervisores</label>

                        <b-form-group>
                          <b-form-checkbox-group
                            id="seller-zonal-checkbox-list"
                            v-model="form.supervisor"
                            :options="supervisorList"
                            name="supervisors"
                          ></b-form-checkbox-group>
                        </b-form-group>

                        <form-error
                          message="Supervisor es requerido"
                          v-if="$v.form.supervisor.$error && !$v.form.supervisor.required"
                        ></form-error>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="form-section border-0 pt-0">
                  <div class="form-group-buttons text-right">
                    <a
                      @click="$router.push({name: 'celulares-supervisors-list'})"
                      class="button button-light"
                    >
                      {{ editing ? "Volver" : "Cancelar" }}
                    </a>
                    <button class="button button-primary" type="submit">
                      Guardar
                    </button>
                  </div>
                </div>
              </form>
            </b-card-body>
          </b-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Constants as LocalConstants } from "@/core/utils";

import {
  Alert,
  Constants,
  FormError,
  FormInput,
  FormSelect
} from "wize-admin";

import { ProductService } from "@/core/services";

import { required } from "vuelidate/lib/validators";

import geoDataMixin from "@/core/Mixins/geoDataMixin"

export default {
  mixins: [geoDataMixin],
  data() {
    return {
      identifierTypes: [
        LocalConstants.IdentifierType.DNI,
        LocalConstants.IdentifierType.RUC,
        LocalConstants.IdentifierType.CE,
        LocalConstants.IdentifierType.PASAPORTE,
      ],
      supervisorTypes: [
        LocalConstants.SupervisorTypes.AD,
        LocalConstants.SupervisorTypes.PUSHER
      ],
      zonalList: [],
      supervisorList: [
        {
          value: "1",
          text: "Supervisor 1",
        },
        {
          value: "2",
          text: "Supervisor 2",
        },
        {
          value: "3",
          text: "Supervisor 3",
        }
      ],
      form: {
        identifier: null,
        identifierType: null,
        name: null,
        admissionDate: null,
        channel: null,
        supervisorType: null,
        expenseLine: null,
        area: null,
        zonal: [],
        supervisor: []
      },
      editing: false,
    };
  },
  components: {
    FormError,
    FormSelect,
    FormInput
  },
  validations: {
    form: {
      identifierType: { required },
      identifier: { required },
      name: { required },
      channel: { required },
      supervisorType: { required },
      expenseLine: { required },
      area: { required },
      zonal: { required },
      supervisor: { required }
    },
  },
  watch: {
    "$route.params.id": function () {
      if (this.$route.params.id) this.load(this.$route.params.id);
    },
  },
  methods: {
    async onChange(files) {
      if (!files.length) return;

      try {
        let filesId = await this.uploadFiles(files);
        filesId = filesId.map((item) => item.id);

        this.product.assetIds.push(...filesId);
      } catch (error) {
        Alert.error(error);
      }
    },
    async save() {
      this.$v.$touch();

      if (this.$v.$error) {
        this.$nextTick(() => {
          this.$smoothScroll({
            scrollTo: document.querySelector(".form-error"),
            updateHistory: false,
            offset: -50,
          });
        });
        return;
      }

      this.$store.dispatch("app/loading", true);
      const data = {};

      try {
        let response;
        if (!this.editing) {
          response = await ProductService.save(data);

          if (response.status == "OK") {
            // Eliminar variaciones anteriores
            this.variations = [];
          }
        } else {
          response = await ProductService.update(this.$route.params.id, data);
        }

        if (response.status == "OK") {
          Alert.success("Se almacenó la información correctamente");
          if (!this.editing) {
            this.$router.push({
              name: "products-edit",
              params: { id: response.payload.id },
            });
            this.editing = true;
          }
        }
      } catch (ex) {
        Alert.error(ex.errors.message);
      } finally {
        this.$store.dispatch("app/loading", false);
      }
    },
    async load(id) {
      try {
        this.$store.dispatch("app/loading", true);
        const response = await ProductService.get(id);

        let data = {
          ...response.payload,
          assetIds: [],
        };

        this.product = JSON.parse(JSON.stringify(data));
        if (data.priceVariations) {
          const priceVariations = JSON.parse(data.priceVariations);
          if (priceVariations.VOLUME) {
            this.volumePrices = JSON.parse(priceVariations.VOLUME);
          }
        }

        this.product.supplierId = this.product.supplier
          ? this.product.supplier.id
          : null;
        this.editing = true;
      } catch (ex) {
        console.error(ex);
        let message = ex.errors.message;
        if (message == "No encontrado")
          message = Constants.Errors.RECORD_NOT_FOUND;
        Alert.error(message, () =>
          this.$router.push({ name: "products-list" })
        );
      } finally {
        this.$store.dispatch("app/loading", false);
      }
    },
    removeImage(i) {
      this.product.assetIds.splice(i, 1);
    },
  },
  async created() {
    if (this.$route.params.id) await this.load(this.$route.params.id);

    await this.getZonalList()

    this.zonalList = this.zonalList.map((zonal) => {
      return {
        value: zonal.key,
        text: zonal.label
      };
    })
  },
};
</script>

<style lang="stylus"></style>
